import React, { Fragment } from 'react'
// components
import BotonBack from '../Utiles/BotonBack'
import Subtitulo from '../Utiles/Subtitulo'
// icons
import {
    faArchive,
    faBalanceScale,
    faBarcode,
    faCartPlus,
    faDollarSign,
    faFileAlt,
    faKeyboard,
    faMinus,
    faPercent,
    faPlus,
    faSortNumericUp,
    faTrashAlt,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
// components
import Header from '../Header/Header'
import ModalArticulo from './ArticuloModal/ModalArticulo'
// routes
import { withRouter } from 'react-router-dom'

import Select from 'react-select'
import useEditCompuesto from './hooks/useEditCompuesto'

const EditArticuloCompuesto = ({ history, location, match }) => {
    const {
        formik,
        isHydrating,
        familias,
        marcas,
        unidadMedidas,
        items,
        handleCodigosBarra,
        deleteCodigoBarra,
        codigosBarra,
        setCodigoArticulo,
        inputTotalRef,
        codigoArticulo,
        cantidadArticulo,
        setCantidadArticulo,
        handleKeyPress,
        deleteItem,
        editCompositeArticleSubmit,
    } = useEditCompuesto(history, location, match)

    if (isHydrating) {
        return (
            <Fragment>
                <Header />
                <div className="container-fluid mt-3">
                    <div className="alert alert-dismissible alert-secondary d-flex justify-content-between">
                        <BotonBack />
                        <Subtitulo
                            icon={faBarcode}
                            title={'Editar Articulo Compuesto'}
                        />
                    </div>
                    <div className="bg-gris p-4 text-center">
                        Cargando artículo compuesto...
                    </div>
                </div>
            </Fragment>
        )
    }

    return (
        <Fragment>
            <Header />
            <div className="container-fluid mt-3">
                <div className="alert alert-dismissible alert-secondary d-flex justify-content-between">
                    <BotonBack />
                    <Subtitulo
                        icon={faBarcode}
                        title={'Editar Articulo Compuesto'}
                    />
                </div>
                <div className="bg-gris p-4">
                    <div className="form-row">
                        <div className="form-group col-md-4">
                            <label htmlFor="inputNombre">Nombre</label>
                            <div className="input-group-prepend">
                                <span
                                    className="input-group-text"
                                    id="inputGroupPrepend"
                                >
                                    <FontAwesomeIcon icon={faCartPlus} />
                                </span>
                                <input
                                    type="text"
                                    id="inputNombre"
                                    name="nombre"
                                    className="form-control"
                                    placeholder="Ej. Lacteos, Gaseosas..."
                                    value={formik.values.nombre}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                />
                            </div>
                            {formik.touched.nombre && formik.errors.nombre ? (
                                <small className="form-text text-danger">
                                    {formik.errors.nombre}
                                </small>
                            ) : null}
                        </div>
                        <div className="form-group col-md-4">
                            <label htmlFor="inputCosto">Costo</label>
                            <div className="input-group-prepend">
                                <span
                                    className="input-group-text"
                                    id="inputGroupPrepend"
                                >
                                    <FontAwesomeIcon icon={faDollarSign} />
                                </span>
                                <input
                                    type="text"
                                    className="form-control"
                                    step="any"
                                    id="inputCosto"
                                    name="costo"
                                    placeholder="Ej. 100, 200,..."
                                    value={formik.values.costo}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                />
                            </div>
                            {formik.touched.costo && formik.errors.costo ? (
                                <small className="form-text text-danger">
                                    {formik.errors.costo}
                                </small>
                            ) : null}
                        </div>
                        <div className="form-group col-md-4">
                            <label htmlFor="inputPrecioFinal">
                                Precio Final
                            </label>
                            <div className="input-group-prepend">
                                <span
                                    className="input-group-text"
                                    id="inputGroupPrepend"
                                >
                                    <FontAwesomeIcon icon={faDollarSign} />
                                </span>
                                <input
                                    type="number"
                                    step="any"
                                    id="inputPrecioFinal"
                                    name="precioFinal"
                                    className="form-control"
                                    placeholder="$250"
                                    value={formik.values.precioFinal}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="form-row">
                        <div className="form-group col-md-4">
                            <label htmlFor="inputPGanancia">
                                Porcentaje Ganancia
                            </label>
                            <div className="input-group-prepend">
                                <span
                                    className="input-group-text"
                                    id="inputGroupPrepend"
                                >
                                    <FontAwesomeIcon icon={faPercent} />
                                </span>
                                <input
                                    type="text"
                                    id="inputPGanancia"
                                    name="porcentajeGanancia"
                                    className="form-control"
                                    placeholder="10, 20"
                                    value={formik.values.porcentajeGanancia}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                />
                            </div>
                        </div>
                        <div className="form-group col-md-4">
                            <label htmlFor="inputPesable">Pesable</label>
                            <div className="input-group-prepend">
                                <span
                                    className="input-group-text"
                                    id="inputGroupPrepend"
                                >
                                    <FontAwesomeIcon icon={faArchive} />
                                </span>
                                <select
                                    id="inputPesable"
                                    className="custom-select"
                                    name="pesable"
                                    value={formik.values.pesable}
                                    onChange={(e) => {
                                        formik.handleChange(e)
                                        if (String(e.target.value) !== 'true') {
                                            formik.setFieldValue(
                                                'porcentajePerdida',
                                                0
                                            )
                                        }
                                    }}
                                    onBlur={formik.handleBlur}
                                    disabled
                                >
                                    <option value={true}>Si</option>
                                    <option value={false}>No</option>
                                </select>
                            </div>
                        </div>
                        <div className="form-group col-md-4">
                            <label htmlFor="inputPesoPromedio">
                                Peso promedio
                            </label>
                            <div className="input-group-prepend">
                                <span
                                    className="input-group-text"
                                    id="inputGroupPrepend"
                                >
                                    <FontAwesomeIcon icon={faBalanceScale} />
                                </span>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="inputPesoPromedio"
                                    name="pesoPromedio"
                                    placeholder="medida en gramos"
                                    value={formik.values.pesoPromedio}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    disabled
                                />
                            </div>
                        </div>
                        {String(formik.values.pesable) === 'true' && (
                            <div className="form-group col-md-4">
                                <label htmlFor="inputPorcentajePerdida">
                                    Porcentaje Perdida
                                </label>
                                <div className="input-group-prepend">
                                    <span
                                        className="input-group-text"
                                        id="inputGroupPrepend"
                                    >
                                        <FontAwesomeIcon icon={faPercent} />
                                    </span>
                                    <input
                                        type="text"
                                        id="inputPorcentajePerdida"
                                        name="porcentajePerdida"
                                        className="form-control"
                                        placeholder="0 - 100"
                                        value={formik.values.porcentajePerdida}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                    />
                                </div>
                                {formik.touched.porcentajePerdida &&
                                formik.errors.porcentajePerdida ? (
                                    <small className="form-text text-danger">
                                        {formik.errors.porcentajePerdida}
                                    </small>
                                ) : null}
                            </div>
                        )}
                    </div>
                    <div className="form-row">
                        <div className="form-group col-md-4">
                            <label htmlFor="inputBalanza">Balanza</label>
                            <div className="input-group-prepend">
                                <span
                                    className="input-group-text"
                                    id="inputGroupPrepend"
                                >
                                    <FontAwesomeIcon icon={faBalanceScale} />
                                </span>
                                <select
                                    id="inputBalanza"
                                    className="custom-select"
                                    name="balanza"
                                    value={formik.values.balanza}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                >
                                    <option value={true}>Si</option>
                                    <option value={false}>No</option>
                                </select>
                            </div>
                        </div>
                        <div className="form-group col-md-4">
                            <label htmlFor="inputCodProducto">
                                Codigo del producto
                            </label>
                            <div className="input-group-prepend">
                                <span
                                    className="input-group-text"
                                    id="inputGroupPrepend"
                                >
                                    <FontAwesomeIcon icon={faKeyboard} />
                                </span>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="inputCodProducto"
                                    name="codigo"
                                    placeholder="Ej 100"
                                    value={formik.values.codigo}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                />
                            </div>
                            {formik.touched.codigo && formik.errors.codigo ? (
                                <small className="form-text text-danger">
                                    {formik.errors.codigo}
                                </small>
                            ) : null}
                        </div>
                        <div className="form-group col-md-4">
                            <label htmlFor="inputDescripcion">
                                Descripcion
                            </label>
                            <div className="input-group-prepend">
                                <span
                                    className="input-group-text"
                                    id="inputGroupPrepend"
                                >
                                    <FontAwesomeIcon icon={faFileAlt} />
                                </span>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="inputDescripcion"
                                    name="descripcion"
                                    placeholder="Ej. producto envasado"
                                    value={formik.values.descripcion}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="form-row">
                        <div className="form-group col-md-4">
                            <label htmlFor="inputFamilia">Familia</label>
                            <div>
                                <Select
                                    placeholder={'Seleccionar una familia'}
                                    options={familias}
                                    defaultValue={formik.values.familia}
                                    onChange={(value) =>
                                        formik.setFieldValue('familia', value)
                                    }
                                    getOptionValue={(values) => values.id}
                                    getOptionLabel={(values) => values.nombre}
                                ></Select>
                            </div>
                            {formik.touched.familia && formik.errors.familia ? (
                                <small className="form-text text-danger">
                                    {formik.errors.familia}
                                </small>
                            ) : null}
                        </div>
                        <div className="form-group col-md-4">
                            <label htmlFor="inputMarca">Marca</label>
                            <div>
                                <Select
                                    placeholder={'Seleccionar una marca'}
                                    options={marcas}
                                    defaultValue={formik.values.marca}
                                    onChange={(value) =>
                                        formik.setFieldValue('marca', value)
                                    }
                                    getOptionValue={(values) => values.id}
                                    getOptionLabel={(values) => values.nombre}
                                ></Select>
                            </div>
                            {formik.touched.marca && formik.errors.marca ? (
                                <small className="form-text text-danger">
                                    {formik.errors.marca}
                                </small>
                            ) : null}
                        </div>
                        <div className="form-group col-md-4">
                            <label htmlFor="inputUnidadMedida">
                                Unidad Medida
                            </label>
                            <div>
                                <Select
                                    placeholder={
                                        'Seleccionar una unidad de medida'
                                    }
                                    options={unidadMedidas}
                                    defaultValue={formik.values.unidadMedida}
                                    onChange={(value) =>
                                        formik.setFieldValue(
                                            'unidadMedida',
                                            value
                                        )
                                    }
                                    getOptionValue={(values) => values.id}
                                    getOptionLabel={(values) => values.nombre}
                                ></Select>
                            </div>
                            {formik.touched.unidadMedida &&
                            formik.errors.unidadMedida ? (
                                <small className="form-text text-danger">
                                    {formik.errors.unidadMedida}
                                </small>
                            ) : null}
                        </div>
                    </div>
                    <div className="form-row">
                        <div className="form-group col-md-6">
                            <label htmlFor="inputPuntos">Puntos</label>
                            <div className="input-group-prepend">
                                <span
                                    className="input-group-text"
                                    id="inputGroupPrepend"
                                >
                                    <FontAwesomeIcon icon={faSortNumericUp} />
                                </span>
                                <input
                                    type="number"
                                    className="form-control"
                                    step="any"
                                    id="inputPuntos"
                                    name="puntos"
                                    placeholder="Ej. 0"
                                    value={formik.values.puntos}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                />
                            </div>
                        </div>
                        <div className="form-group col-md-6">
                            <label htmlFor="inputCodBarra">
                                Codigos de Barra
                            </label>
                            <div className="input-group-prepend">
                                <span
                                    className="input-group-text"
                                    id="inputGroupPrepend"
                                >
                                    <FontAwesomeIcon icon={faBarcode} />
                                </span>
                                <input
                                    type="number"
                                    className="form-control"
                                    id="inputCodBarra"
                                    name="codigoBarra"
                                    placeholder="Ej. 77555511999"
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            e.preventDefault()
                                            e.stopPropagation()
                                            handleCodigosBarra(e)
                                        }
                                    }}
                                />
                            </div>
                            <ul className="list-group">
                                {codigosBarra.map((cb) => {
                                    return (
                                        <li
                                            id={'cod' + cb.codigo}
                                            key={parseInt(cb.codigo)}
                                            className="list-group-item d-flex justify-content-between align-items-center"
                                        >
                                            {cb.codigo}
                                            <button
                                                className="btn btn-primary"
                                                onClick={(e) =>
                                                    deleteCodigoBarra(
                                                        e,
                                                        cb.codigo
                                                    )
                                                }
                                            >
                                                <FontAwesomeIcon
                                                    icon={faMinus}
                                                />
                                            </button>
                                        </li>
                                    )
                                })}
                            </ul>
                        </div>
                    </div>
                    <div className="d-flex bd-highlight">
                        <div className="p-2 bd-highlight">
                            <ModalArticulo
                                setCodigoArticulo={setCodigoArticulo}
                                inputTotalRef={inputTotalRef}
                            />
                        </div>
                        <div className="p-2 flex-grow-1 bd-highlight">
                            <input
                                className="form-control form-control-lg"
                                style={{ height: 45 }}
                                type="text"
                                placeholder="Ingrese un articulo"
                                value={codigoArticulo || ''}
                                ref={inputTotalRef}
                                onChange={(e) =>
                                    setCodigoArticulo(e.target.value)
                                }
                            />
                        </div>
                        <div className="p-2 flex-grow-1 bd-highlight">
                            <input
                                className="form-control form-control-lg"
                                style={{ height: 45 }}
                                type="text"
                                placeholder="cantidad"
                                value={cantidadArticulo}
                                onChange={(e) =>
                                    setCantidadArticulo(e.target.value)
                                }
                            />
                        </div>
                        <div className="p-2 bd-highlight">
                            <button
                                className="btn btn-outline-success btn-lg"
                                onClick={() => handleKeyPress()}
                            >
                                <FontAwesomeIcon icon={faPlus} /> Añadir
                            </button>
                        </div>
                    </div>
                    <table className="table">
                        <thead className="thead-dark">
                            <tr>
                                <th scope="col">Codigo</th>
                                <th scope="col">Producto</th>
                                <th scope="col">Precio</th>
                                <th scope="col">Familia</th>
                                <th scope="col">Cantidad</th>
                                <th scope="col">Eliminar</th>
                            </tr>
                        </thead>
                        <tbody>
                            {items
                                ? items.map((item) => {
                                      return (
                                          <tr key={parseInt(item.id, 10)}>
                                              <th scope="row">
                                                  <h4>{item.codigo}</h4>
                                              </th>
                                              <td>
                                                  <h4>{item.articulo}</h4>{' '}
                                              </td>
                                              <td>
                                                  <h4>{item.costo}</h4>{' '}
                                              </td>
                                              <td>
                                                  <h4>
                                                      {item.familia?.nombre}
                                                  </h4>{' '}
                                              </td>
                                              <td>
                                                  <h4>{item.cantidad}</h4>{' '}
                                              </td>
                                              <td>
                                                  <button
                                                      className="btn btn-outline-primary"
                                                      onClick={() =>
                                                          deleteItem(item)
                                                      }
                                                  >
                                                      <FontAwesomeIcon
                                                          icon={faTrashAlt}
                                                      />
                                                  </button>
                                              </td>
                                          </tr>
                                      )
                                  })
                                : null}
                        </tbody>
                    </table>
                    <div className="text-center">
                        <button
                            className="btn btn-outline-danger btn-lg"
                            onClick={() =>
                                formik.validateForm().then((errors) => {
                                    if (Object.keys(errors).length) {
                                        formik.setTouched(
                                            Object.keys(formik.values).reduce(
                                                (acc, key) => {
                                                    acc[key] = true
                                                    return acc
                                                },
                                                {}
                                            )
                                        )
                                        return
                                    }
                                    editCompositeArticleSubmit(formik.values)
                                })
                            }
                        >
                            <FontAwesomeIcon icon={faPlus} /> Guardar artículo
                            compuesto
                        </button>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}
export default withRouter(EditArticuloCompuesto)
